export const GET_COMMONCATEGORY_STARTED = "GET_COMMONCATEGORY_STARTED";
export const GET_COMMONCATEGORY_COMPLETED = "GET_COMMONCATEGORY_COMPLETED";
export const GET_COMMONCATEGORY_FAILED = "GET_COMMONCATEGORY_FAILED";

export interface IAaroles {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    aarolesInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    autoid: number;
    isLoading: boolean;
    error: string;
}


export const getCOMMONCATEGORYList = (autoid) => {
    //alert("newid");
    return {
        type: GET_COMMONCATEGORY_STARTED ,
        payload: 'Value',
        input:autoid
    };
};